<div class="as-loader-container">
  <ng-lottie width="300px" height="300px" [options]="options"> </ng-lottie>
  <mat-label class="as-warnig-location">
    {{ 'PURCHASE.loading' | translate }}
  </mat-label>
</div>
